import { render, staticRenderFns } from "./DualGraphicsPdfComponent.vue?vue&type=template&id=2a39985c&scoped=true"
import script from "./DualGraphicsPdfComponent.vue?vue&type=script&lang=js"
export * from "./DualGraphicsPdfComponent.vue?vue&type=script&lang=js"
import style0 from "./DualGraphicsPdfComponent.vue?vue&type=style&index=0&id=2a39985c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39985c",
  null
  
)

export default component.exports